import { ref, type Ref } from "vue";
import type FormCC from "@/interface/FormCC";
import MasterService from "@/service/restfulService/CCOnboardMasterService";

export default function additionalInfomationSubmit(
  ccFormValue: Ref<FormCC>,
  prop: any,
  page15Overlay: Ref<boolean>,
  isTimeOut: Ref<boolean>,
  isSessionEnd: Ref<boolean>,
  jumpStep: (value: number, name: string, page: string) => void,
  getProductStepFromBackend: (
    forward: boolean,
    backward: boolean,
    resume: boolean,
    autoPopulated: boolean,
    summaryEditBtn: string
  ) => void
): void {
  const postCode = ref("80000");
  const city = ref("");
  const state = ref("");
  isTimeOut.value = false;
  page15Overlay.value = true;
  const requestModel = {
    dropOffStep: "P1",
    webFormRequestId: ccFormValue.value.webFormRequestId,
    cardId: prop.cardId,
    icNumber: ccFormValue.value.basicInformation.idNo,
    webFormDetails: {
      basicInformation: {
        // title: ccFormValue.value.value.basicInformation.title,
        fullName: ccFormValue.value.basicInformation.name,
        idTypeCode: ccFormValue.value.basicInformation.idType,
        idNo: ccFormValue.value.basicInformation.idNo,
        oldIc:
          ccFormValue.value.basicInformation.idType == "1"
            ? ""
            : ccFormValue.value.basicInformation.oldIc,
        militaryNo:
          ccFormValue.value.basicInformation.idType == "1"
            ? ""
            : ccFormValue.value.basicInformation.militaryNo,
        nationalityCode: ccFormValue.value.basicInformation.nationality,
        dateOfBirth: ccFormValue.value.basicInformation.dob,
        emailAddress: ccFormValue.value.basicInformation.email,
        mobileCountryCode: ccFormValue.value.basicInformation.countryCode,
        mobileNumber: ccFormValue.value.basicInformation.mobileNo,
        homePhoneCountryCode:
          ccFormValue.value.basicInformation.homePhoneNo != ""
            ? ccFormValue.value.basicInformation.homeCountryCode
            : "",
        homePhoneNumber: ccFormValue.value.basicInformation.homePhoneNo,
        grossMonthlySalary: ccFormValue.value.basicInformation.grossSalary,
        netMonthlySalary: ccFormValue.value.basicInformation.netSalary,
        professionCode: ccFormValue.value.basicInformation.profession,
        professionOthers: ccFormValue.value.basicInformation.others,
        anyLoan:
          ccFormValue.value.basicInformation.question1 == "Yes" ? true : false,
        repayment: ccFormValue.value.basicInformation.repayment,
      },
      personInformation: {
        title: ccFormValue.value.personalInformation.title,
        genderCode: ccFormValue.value.personalInformation.gender,
        raceCode: ccFormValue.value.personalInformation.race,
        otherRace: ccFormValue.value.personalInformation.otherRace,
        residencyStatusCode:
          ccFormValue.value.basicInformation.nationality == "MY"
            ? ccFormValue.value.personalInformation.residencyStatus
            : "U",
        maritalStatusCode: ccFormValue.value.personalInformation.maritalStatus,
        motherMaidenName:
          ccFormValue.value.personalInformation.motherMaidenName,
        numberOfDependents: ccFormValue.value.personalInformation.dependency,
        academicQualification: ccFormValue.value.personalInformation.academic,
        otherQualification: ccFormValue.value.personalInformation.otherAcademic,
        residentialAddress: {
          addressLine1:
            ccFormValue.value.personalInformation.residentialAddress1,
          addressLine2:
            ccFormValue.value.personalInformation.residentialAddress2,
          addressLine3:
            ccFormValue.value.personalInformation.residentialAddress3,
          postcode: ccFormValue.value.personalInformation.postCode,
          city: ccFormValue.value.personalInformation.city,
          state: ccFormValue.value.personalInformation.state,
          durationOfStay: {
            year: ccFormValue.value.personalInformation.yearStay,
            month: ccFormValue.value.personalInformation.monthStay,
          },
        },
        residentialOwnership:
          ccFormValue.value.personalInformation.residentialOwnership,
        permanentAddress: {
          addressLine1: ccFormValue.value.personalInformation.permanentAddress1,
          addressLine2: ccFormValue.value.personalInformation.permanentAddress2,
          addressLine3: ccFormValue.value.personalInformation.permanentAddress3,
          postcode: ccFormValue.value.personalInformation.postCode2,
          city: ccFormValue.value.personalInformation.city2,
          state: ccFormValue.value.personalInformation.state2,
        },
      },
      principalCardDetail: {
        name: ccFormValue.value.principalDetails.name,
        deliveryOption: ccFormValue.value.principalDetails.deliveryOption,
        branchName: ccFormValue.value.principalDetails.branch,
        branchValue: ccFormValue.value.principalDetails.branchValue,
        deliveryAddress: {
          addressLine1:
            ccFormValue.value.principalDetails.deliveryOption == "H"
              ? ccFormValue.value.principalDetails.address1
              : "",
          addressLine2:
            ccFormValue.value.principalDetails.deliveryOption == "H"
              ? ccFormValue.value.principalDetails.address2
              : "",
          addressLine3:
            ccFormValue.value.principalDetails.deliveryOption == "H"
              ? ccFormValue.value.principalDetails.address3
              : "",
          postcode:
            ccFormValue.value.principalDetails.deliveryOption == "H"
              ? ccFormValue.value.principalDetails.postCode
              : "",
          city:
            ccFormValue.value.principalDetails.deliveryOption == "H"
              ? ccFormValue.value.principalDetails.city
              : "",
          state:
            ccFormValue.value.principalDetails.deliveryOption == "H"
              ? ccFormValue.value.principalDetails.state
              : "",
        },
        billingAddress:
          ccFormValue.value.principalDetails.eStatement == "No"
            ? ccFormValue.value.principalDetails.billingAddress
            : "",
        eStatement:
          ccFormValue.value.principalDetails.eStatement == "Yes" ? true : false,
      },
      employmentDetailInfo: {
        my2ndHome:
          ccFormValue.value.employmentDetails.question1 == "Yes" ? true : false,
        workInMY:
          ccFormValue.value.basicInformation.profession == "20"
            ? ""
            : ccFormValue.value.employmentDetails.question2 == "Yes"
            ? true
            : false,
        occupationType: ccFormValue.value.employmentDetails.occupation,
        employmentType: ccFormValue.value.employmentDetails.employment,
        incomeType: ccFormValue.value.employmentDetails.employmentIncome,
        companyName: ccFormValue.value.employmentDetails.companyName,
        sstRegistrationNo:
          ccFormValue.value.employmentDetails.occupation == "1"
            ? ccFormValue.value.employmentDetails.sstRegistrationNo
            : "",
        companyAddress: {
          addressLine1: ccFormValue.value.employmentDetails.companyAddress1,
          addressLine2: ccFormValue.value.employmentDetails.companyAddress2,
          addressLine3: ccFormValue.value.employmentDetails.companyAddress3,
          postcode:
            ccFormValue.value.basicInformation.profession == "20"
              ? ""
              : ccFormValue.value.employmentDetails.question2 == "Yes"
              ? ccFormValue.value.employmentDetails.postCode
              : postCode.value,
          city:
            ccFormValue.value.employmentDetails.question2 == "Yes"
              ? ccFormValue.value.employmentDetails.city
              : city.value,
          state:
            ccFormValue.value.employmentDetails.question2 == "Yes"
              ? ccFormValue.value.employmentDetails.state
              : state.value,
        },
        companyPhoneNoCountryCode:
          ccFormValue.value.employmentDetails.countryCode,
        companyPhoneNo: ccFormValue.value.employmentDetails.phoneNo,
        areaCode: ccFormValue.value.employmentDetails.areaCode,
        natureOfBusiness: ccFormValue.value.employmentDetails.natureBusiness,
        otherNOB: ccFormValue.value.employmentDetails.others,
        lengthOfEmployment: {
          year:
            ccFormValue.value.employmentDetails.yearEmp == ""
              ? 0
              : ccFormValue.value.employmentDetails.yearEmp,
          month:
            ccFormValue.value.employmentDetails.monthEmp == ""
              ? 0
              : ccFormValue.value.employmentDetails.monthEmp,
        },
      },
    },
  };
  MasterService.additionalInfomationSubmit(
    requestModel,
    ccFormValue.value.token
  )
    .then((res) => {
      if (res.status == 200) {
        isTimeOut.value = true;
        //TODO-Matrix
        if (
          ccFormValue.value.summarySetting.additionalInformationJump == true
        ) {
          ccFormValue.value.summarySetting.additionalInformationJump = false;
          getProductStepFromBackend(false, false, false, false, "Summary");
          page15Overlay.value = false;
        } else {
          getProductStepFromBackend(true, false, false, false, "");
          page15Overlay.value = false;
        }
      }
    })
    .catch((e) => {
      if (e.response && e.response.data.code == "WB-401") {
        // EndSession
        isTimeOut.value = false;
        isSessionEnd.value = true;
      }
      page15Overlay.value = false;
      isTimeOut.value = true;
    });
}
